import { render, staticRenderFns } from "./ModalCadastroSetor.vue?vue&type=template&id=6e7fc96d&scoped=true"
import script from "./ModalCadastroSetor.vue?vue&type=script&lang=js"
export * from "./ModalCadastroSetor.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastroSetor.vue?vue&type=style&index=0&id=6e7fc96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fc96d",
  null
  
)

export default component.exports